import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSpreadInfoStore = defineStore('spreadInfo', () => {
  const landingPageType = ref('')
  const utm_campaign_id = ref('')
  const utm_medium = ref('')
  const utm_adset_id = ref('')
  const utm_ad_id = ref('')
  const pId = ref('')
  const adDomainId = ref('')
  const bizAdId = ref('')

  function setSpreadInfo(data: Record<string, any>) {
    if (data.landingPageType !== undefined)
      landingPageType.value = data.landingPageType
    if (data.utm_campaign_id !== undefined)
      utm_campaign_id.value = data.utm_campaign_id
    if (data.utm_medium !== undefined)
      utm_medium.value = data.utm_medium
    if (data.utm_adset_id !== undefined)
      utm_adset_id.value = data.utm_adset_id
    if (data.utm_ad_id !== undefined)
      utm_ad_id.value = data.utm_ad_id
    if (data.pId !== undefined)
      pId.value = data.pId
    if (data.adDomainId !== undefined)
      adDomainId.value = data.adDomainId
    if (data.bizAdId !== undefined)
      bizAdId.value = data.bizAdId
  }

  return { landingPageType, utm_campaign_id, utm_medium, utm_adset_id, utm_ad_id, pId, adDomainId, bizAdId, setSpreadInfo }
})
